<template>
  <div class="pt-4">
    <h6 v-if="isMobile && activeMake" class="pb-3">
      {{ isMobileBreadcrumb }}
    </h6>
    <div class="row">
      <div
        class="col-lg-4 col-md-6 mb-4"
        v-if="isMobile ? showCard === 0 : true"
      >
        <b-card no-body>
          <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="mb-0">選擇品牌</h6>
              <b-button
                squared
                variant="manage_main"
                type="button"
                v-b-modal.modalCategory
                @click="showModal('add', 1)"
                >新增</b-button
              >
            </div>
            <b-input-group class="mt-3 mb-2 ml-auto search-group">
              <b-input-group-prepend is-text>
                <b-icon-search></b-icon-search>
              </b-input-group-prepend>
              <b-form-input
                v-model="searchMake"
                placeholder="搜尋品牌名稱"
              ></b-form-input>
              <b-button-close
                class="pr-2"
                v-if="searchMake"
                @click="clearMakeFilter"
              ></b-button-close>
            </b-input-group>
          </template>
          <b-list-group flush>
            <template v-if="filteredMakeList && filteredMakeList.length > 0">
              <b-list-group-item
                v-for="item in filteredMakeList"
                :key="item.id"
                class="d-flex justify-content-between align-items-center"
                href="#"
                @click="clickMake(item.id)"
                :active="item.id == activeMake"
              >
                {{ item.name }}
                <b-dropdown
                  right
                  no-caret
                  variant="link"
                  boundary="viewport"
                  class="btn-only-icon"
                >
                  <template v-slot:button-content>
                    <b-icon icon="three-dots-vertical" variant="dark"></b-icon>
                  </template>
                  <b-dropdown-item
                    href="#"
                    @click.stop="showModal('edit', 1, item.id)"
                    >編輯</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="!item.count"
                    @click.stop="deleteBrand(item.id)"
                    link-class="text-danger"
                    >刪除</b-dropdown-item
                  >
                </b-dropdown>
              </b-list-group-item>
            </template>
            <b-list-group-item class="text-center" v-else>
              {{
                searchMake ? "沒有找到符合的汽車品牌" : "目前尚無資料，請新增"
              }}
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </div>
      <div
        class="col-lg-4 col-md-6 mb-4"
        v-if="isMobile ? showCard === 1 : activeMake"
      >
        <b-card no-body>
          <template v-slot:header>
            <div
              class="d-flex flex-row justify-content-between align-items-center"
            >
              <div class="d-flex align-items-center btn-only-icon">
                <b-button
                  @click="goBackCard"
                  v-if="isMobile"
                  class="btn-link mr-2"
                  variant="outline-light"
                  size="sm"
                >
                  <b-icon icon="chevron-left" variant="dark"></b-icon>
                </b-button>
                <h6 class="mb-0">選擇車款</h6>
              </div>
              <b-button
                squared
                variant="manage_main"
                type="button"
                @click="showModal('add', 2)"
                >新增</b-button
              >
            </div>
            <b-input-group class="mt-3 mb-2 ml-auto search-group">
              <b-input-group-prepend is-text>
                <b-icon-search></b-icon-search>
              </b-input-group-prepend>
              <b-form-input
                v-model="searchModel"
                placeholder="搜尋車款名稱"
              ></b-form-input>
              <b-button-close
                class="pr-2"
                v-if="searchModel"
                @click="clearModelFilter"
              ></b-button-close>
            </b-input-group>
          </template>
          <b-list-group flush>
            <template v-if="filteredModelList && filteredModelList.length > 0">
              <b-list-group-item
                v-for="item in filteredModelList"
                :key="item.id"
                class="d-flex justify-content-between align-items-center"
                href="#"
                @click="clickModel(activeMake, item.id)"
                :active="item.id == activeModel"
              >
                {{ item.name }}
                <b-dropdown
                  right
                  no-caret
                  variant="link"
                  boundary="viewport"
                  class="btn-only-icon"
                >
                  <template v-slot:button-content>
                    <b-icon icon="three-dots-vertical" variant="dark"></b-icon>
                  </template>
                  <b-dropdown-item
                    href="#"
                    @click.stop="showModal('edit', 2, item.id)"
                    >編輯</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="!item.count"
                    @click.stop="deleteModel(item.car_brand_id, item.id)"
                    link-class="text-danger"
                    >刪除</b-dropdown-item
                  >
                </b-dropdown>
              </b-list-group-item>
            </template>
            <b-list-group-item class="text-center" v-else>
              {{ searchModel ? "沒有找到符合的車款" : "目前尚無資料，請新增" }}
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </div>
      <div
        class="col-lg-4 col-md-6 mb-4"
        v-if="isMobile ? showCard === 2 : activeModel"
      >
        <b-card no-body>
          <template v-slot:header>
            <div
              class="d-flex flex-row justify-content-between align-items-center"
            >
              <div class="d-flex align-items-center btn-only-icon">
                <b-button
                  @click="goBackCard"
                  v-if="isMobile"
                  class="btn-link mr-2"
                  variant="outline-light"
                  size="sm"
                >
                  <b-icon icon="chevron-left" variant="dark"></b-icon>
                </b-button>
                <h6 class="mb-0">年份</h6>
              </div>
              <b-button
                squared
                variant="manage_main"
                type="button"
                @click="showModal('add', 3)"
                >新增</b-button
              >
            </div>
            <b-input-group class="mt-3 mb-2 ml-auto search-group">
              <b-input-group-prepend is-text>
                <b-icon-search></b-icon-search>
              </b-input-group-prepend>
              <b-form-input
                v-model="searchYear"
                placeholder="搜尋年份"
              ></b-form-input>
              <b-button-close
                class="pr-2"
                v-if="searchYear"
                @click="clearYearFilter"
              ></b-button-close>
            </b-input-group>
          </template>
          <b-list-group flush>
            <template v-if="filteredYearList && filteredYearList.length > 0">
              <b-list-group-item
                v-for="item in filteredYearList"
                :key="item.id"
                class="d-flex justify-content-between align-items-center"
              >
                {{
                  item.publish_year +
                    " ( " +
                    getTypeName(item.type) +
                    " / " +
                    item.displacing +
                    " c.c. )"
                }}
                <b-dropdown
                  right
                  no-caret
                  variant="link"
                  boundary="viewport"
                  class="btn-only-icon"
                >
                  <template v-slot:button-content>
                    <b-icon icon="three-dots-vertical" variant="dark"></b-icon>
                  </template>
                  <b-dropdown-item @click="showModal('edit', 3, item.id)"
                    >編輯</b-dropdown-item
                  >
                  <b-dropdown-item @click="showModal('copy', 3, item.id)"
                    >複製</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="!item.count"
                    @click.stop="
                      deleteYear(item.car_brand_id, item.car_model_id, item.id)
                    "
                    link-class="text-danger"
                    >刪除</b-dropdown-item
                  >
                </b-dropdown>
              </b-list-group-item>
            </template>
            <b-list-group-item class="text-center" v-else>
              {{ searchYear ? "沒有找到符合的年份" : "目前尚無資料，請新增" }}
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </div>
    </div>
    <b-modal
      id="modalCategory"
      :title="modal.title"
      footer-class="d-flex justify-content-between"
      no-close-on-backdrop
      centered
      tall
      size="sm"
      @ok="onSubmit"
      @show="onShowModal"
      @hidden="onHiddenModal"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          v-if="modal.level != 3"
          :label="modal.labelName"
          label-for="categorName"
          :invalid-feedback="invalidFeedback"
          :state="modal.state.name"
          class="required"
        >
          <b-form-input
            id="categorName"
            class="rounded-0"
            v-model="modal.form.name"
            type="text"
            required
            :state="modal.state.name"
          ></b-form-input>
        </b-form-group>
        <template v-else>
          <b-form-group
            label="選擇年份"
            label-for="categorYear"
            :invalid-feedback="invalidFeedbackYear"
            :state="modal.state.publish_year"
            class="required"
          >
            <b-form-select
              v-model="modal.form.publish_year"
              id="categorYear"
              required
              class="rounded-0"
              :state="modal.state.publish_year"
            >
              <b-form-select-option value="" disabled selected
                >請選擇</b-form-select-option
              >
              <b-form-select-option
                v-for="n in getThisYear() + 2 - 1950"
                :value="getThisYear() + 2 - n"
                :key="n"
                >{{ getThisYear() + 2 - n }}</b-form-select-option
              >
            </b-form-select>
          </b-form-group>
          <b-form-group
            label="選擇動力類型"
            label-for="categorType"
            :invalid-feedback="invalidFeedbackType"
            :state="modal.state.type"
            class="required"
          >
            <b-form-select
              v-model="modal.form.type"
              id="categorType"
              required
              class="rounded-0"
              :state="modal.state.type"
            >
              <b-form-select-option value="" disabled selected
                >請選擇</b-form-select-option
              >
              <b-form-select-option
                v-for="(item, index) in option.type"
                :value="item.value"
                :key="index"
                >{{ item.name }}</b-form-select-option
              >
            </b-form-select>
          </b-form-group>
          <b-form-group
            label="選擇c.c.數"
            label-for="categorDisplacing"
            :invalid-feedback="invalidFeedbackDisplacing"
            :state="modal.state.displacing"
            class="required"
          >
            <b-form-select
              v-model="modal.form.displacing"
              id="categorDisplacing"
              required
              class="rounded-0"
              :state="modal.state.displacing"
            >
              <b-form-select-option value="" disabled selected
                >請選擇</b-form-select-option
              >
              <b-form-select-option
                v-for="(item, index) in option.displacing"
                :value="item"
                :key="index"
                >{{ item }}</b-form-select-option
              >
            </b-form-select>
          </b-form-group>
        </template>
      </form>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button squared variant="outline-dark" type="button" @click="cancel()"
          >取消</b-button
        >
        <b-button squared variant="manage_main" type="submit" @click="ok()"
          >儲存</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.list-group {
  height: 316px;
  overflow-y: auto;
  @include media-breakpoint-down(sm) {
    height: 344px;
  }
}
.list-group-item.active {
  background-color: #d8e0f5;
  border: 1px solid $manage_main;
  color: $manage_main;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 1px;
}
.search-group {
  border: 1px solid #bdbdbd;
  max-width: 100%;
  margin-top: 20px;
  .input-group-text {
    background-color: #fff;
    border: none;
    border-radius: 0;
    color: #bdbdbd;
  }
  .form-control {
    border: none;
    border-radius: 0;
    &:focus {
      box-shadow: none;
    }
  }
}
</style>

<script>
import { Category } from "@/assets/api/manage.js";
import { Toast, Swal } from "@/plugins/sweetalert2.js";

export default {
  name: "CategoryStyle",
  props: ["isMobile", "token"],
  data() {
    return {
      activeMake: null,
      activeModel: null,
      searchMake: "",
      searchModel: "",
      searchYear: "",
      make: null,
      model: null,
      year: null,
      isEdit: false,
      isModalShow: false,
      showCard: 0,
      option: {
        type: [
          {
            name: "汽油車",
            value: "gas"
          },
          {
            name: "油電車",
            value: "hybrid"
          },
          {
            name: "電動車",
            value: "electric"
          },
          {
            name: "柴油車",
            value: "diesel"
          }
        ],
        displacing: [
          "1.0",
          "1.1",
          "1.2",
          "1.3",
          "1.4",
          "1.5",
          "1.6",
          "1.8",
          "2.0",
          "2.2",
          "2.4",
          "2.5",
          "3.0",
          "3.5"
        ]
      },
      modal: {
        level: null,
        id: null,
        title: "",
        labelName: "",
        state: {
          name: null,
          publish_year: null,
          type: null,
          displacing: null
        },
        form: {
          name: "",
          publish_year: "",
          type: "",
          displacing: ""
        }
      },
      invalidFeedback: "",
      invalidFeedbackYear: "請選擇年份",
      invalidFeedbackType: "請選擇動力類型",
      invalidFeedbackDisplacing: "請選擇c.c.數"
    };
  },
  created() {
    this.apiGetCarBrand();
    this.getThisYear();
  },
  watch: {
    activeMake() {
      this.activeModel = null;
    },
    "modal.form": {
      handler: function() {
        if (this.isModalShow) this.checkFormState();
      },
      deep: true
    }
  },
  computed: {
    filteredMakeList() {
      if (!this.make) return;
      return this.make.filter(data1 => {
        return data1.name.toLowerCase().includes(this.searchMake.toLowerCase());
      });
    },
    filteredModelList() {
      if (!this.model) return;
      return this.model.filter(data2 => {
        return data2.name
          .toLowerCase()
          .includes(this.searchModel.toLowerCase());
      });
    },
    filteredYearList() {
      if (!this.year) return;
      let filteredYear = [];
      Object.filter = obj =>
        Object.keys(obj).filter(data3 =>
          data3.toLowerCase().includes(this.searchYear.toLowerCase())
        );
      Object.filter(this.year).forEach(val => {
        this.year[val].forEach(yearinfo => {
          filteredYear.push(yearinfo);
        });
      });
      return filteredYear;
    },
    isMobileBreadcrumb() {
      if (!this.isMobile) return;
      let breadcrumb_LV_1 = null;
      let breadcrumb_LV_2 = null;
      if (this.activeMake && this.make) {
        this.make.forEach((val, index) => {
          if (val.id == this.activeMake) {
            breadcrumb_LV_1 = this.make[index].name;
          }
        });
      }
      if (this.activeModel && this.model) {
        this.model.forEach((val, index) => {
          if (val.id == this.activeModel) {
            breadcrumb_LV_2 = this.model[index].name;
          }
        });
      }
      return breadcrumb_LV_1 + " / " + (breadcrumb_LV_2 || "");
    }
  },
  methods: {
    getTypeName(type) {
      switch (type) {
        case "electric":
          return "電動車";
        case "hybrid":
          return "油電車";
        case "gas":
          return "汽油車";
        case "diesel":
          return "柴油車";
      }
    },
    getThisYear() {
      const date = new Date();
      return Number(date.getFullYear());
    },
    goBackCard() {
      this.showCard--;
      if (this.showCard) {
        this.activeModel = null;
      } else {
        this.activeMake = null;
      }
    },
    clickMake(Makeid) {
      this.apiGetModel(Makeid);
      if (this.activeMake == Makeid) {
        this.activeMake = null;
        this.showCard = 0;
        this.model = null;
        this.year = null;
      } else {
        this.activeMake = Makeid;
        this.showCard = 1;
      }
    },
    clickModel(Makeid, Modelid) {
      this.apiGetCarYear(Makeid, Modelid);
      if (this.activeModel == Modelid) {
        this.activeModel = null;
        this.showCard = 1;
        this.year = null;
      } else {
        this.activeModel = Modelid;
        this.showCard = 2;
      }
    },
    clearMakeFilter() {
      this.searchMake = "";
    },
    clearModelFilter() {
      this.searchModel = "";
    },
    clearYearFilter() {
      this.searchYear = "";
    },
    resetForm() {
      this.modal.form.name = "";
      this.modal.form.publish_year = "";
      this.modal.form.type = "";
      this.modal.form.displacing = "";

      this.modal.state.name = null;
      this.modal.state.TW_city_town = null;
      this.modal.state.address = null;
      this.modal.state.displacing = null;
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.checkFormState();
      return valid;
    },
    checkFormState() {
      if (this.modal.level !== 3) {
        this.modal.form.name
          ? (this.modal.state.name = null)
          : (this.modal.state.name = false);
      } else {
        this.modal.form.publish_year
          ? (this.modal.state.publish_year = null)
          : (this.modal.state.publish_year = false);
        this.modal.form.type
          ? (this.modal.state.type = null)
          : (this.modal.state.type = false);
        this.modal.form.displacing
          ? (this.modal.state.displacing = null)
          : (this.modal.state.displacing = false);
      }
    },
    apiGetCarBrand() {
      Category.style.brand
        .get("", this.token)
        .then(res => {
          if (res.status <= 201) {
            this.make = res.data;
          } else {
            Toast.fire({
              icon: "error",
              title: "汽車品牌資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    apiGetModel(Makeid) {
      Category.style.model
        .get(Makeid, "", this.token)
        .then(res => {
          if (res.status <= 201) {
            this.model = res.data;
          } else {
            Toast.fire({
              icon: "error",
              title: "汽車型號資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    apiGetCarYear(Makeid, Modelid) {
      Category.style.year
        .get(Makeid, Modelid, "", this.token)
        .then(res => {
          if (res.status <= 201) {
            this.year = res.data;
          } else {
            Toast.fire({
              icon: "error",
              title: "汽車年份資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    deleteBrand(brandId) {
      Swal.fire({
        title: "刪除",
        text: "確定要刪除？",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "取消",
        confirmButtonText: "刪除"
      }).then(result => {
        if (result.value) {
          Category.style.brand
            .del(brandId, this.token)
            .then(res => {
              if (res.status <= 201) {
                this.apiGetCarBrand();
                Toast.fire({
                  icon: "success",
                  title: "刪除成功"
                });
              } else {
                Toast.fire({
                  icon: "error",
                  title: "刪除失敗",
                  text: res.data.error
                });
              }
            })
            .catch(error => {
              console.error(error);
            });
        }
      });
    },
    deleteModel(brandId, Makeid) {
      Swal.fire({
        title: "刪除",
        text: "確定要刪除？",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "取消",
        confirmButtonText: "刪除"
      }).then(result => {
        if (result.value) {
          Category.style.model
            .del(brandId, Makeid, this.token)
            .then(res => {
              if (res.status <= 201) {
                this.apiGetModel(brandId);
                Toast.fire({
                  icon: "success",
                  title: "刪除成功"
                });
              } else {
                Toast.fire({
                  icon: "error",
                  title: "刪除失敗",
                  text: res.data.error
                });
              }
            })
            .catch(error => {
              console.error(error);
            });
        }
      });
    },
    deleteYear(brandId, Makeid, Modelid) {
      Swal.fire({
        title: "刪除",
        text: "確定要刪除？",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "取消",
        confirmButtonText: "刪除"
      }).then(result => {
        if (result.value) {
          Category.style.year
            .del(brandId, Makeid, Modelid, this.token)
            .then(res => {
              if (res.status <= 201) {
                this.apiGetCarYear(brandId, Makeid);
                Toast.fire({
                  icon: "success",
                  title: "刪除成功"
                });
              } else {
                Toast.fire({
                  icon: "error",
                  title: "刪除失敗",
                  text: res.data.error
                });
              }
            })
            .catch(error => {
              console.error(error);
            });
        }
      });
    },
    showModal(action, level, id) {
      this.modal.id = id;
      this.modal.level = level;
      if (action === "edit") {
        this.isEdit = true;
        switch (level) {
          case 1:
            this.modal.title = "編輯汽車品牌";
            this.modal.labelName = "汽車品牌名稱";
            this.make.forEach(element => {
              if (element.id == id) {
                this.modal.form.name = element.name;
              }
            });
            break;
          case 2:
            this.modal.title = "編輯車款";
            this.modal.labelName = "車款名稱";
            this.model.forEach(element => {
              if (element.id == id) {
                this.modal.form.name = element.name;
              }
            });
            break;
          case 3:
            this.modal.title = "編輯年份";
            this.filteredYearList.forEach(element => {
              if (element.id == id) {
                this.modal.form.publish_year = element.publish_year;
                this.modal.form.type = element.type;
                this.modal.form.displacing = element.displacing;
              }
            });
            break;
          default:
            break;
        }
        this.invalidFeedback = "請填寫" + this.modal.labelName;
      } else if (action === "copy") {
        this.modal.title = "複製年份";
        this.filteredYearList.forEach(element => {
          if (element.id == id) {
            this.modal.form.publish_year = element.publish_year;
            this.modal.form.type = element.type;
            this.modal.form.displacing = element.displacing;
          }
        });
      } else {
        this.isEdit = false;
        switch (level) {
          case 1:
            this.modal.title = "新增汽車品牌";
            this.modal.labelName = "汽車品牌名稱";
            break;
          case 2:
            this.modal.title = "新增車款";
            this.modal.labelName = "車款名稱";
            break;
          case 3:
            this.modal.title = "新增年份";
            break;
          default:
            break;
        }
      }
      this.$root.$emit("bv::show::modal", "modalCategory", "#btnShow");
    },
    onShowModal() {
      this.isModalShow = true;
    },
    onHiddenModal() {
      this.isModalShow = false;
      this.resetForm();
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }
      if (this.isEdit) {
        switch (this.modal.level) {
          case 1:
            Category.style.brand
              .update(this.modal.id, { name: this.modal.form.name }, this.token)
              .then(res => {
                if (res.status <= 201) {
                  Toast.fire({
                    icon: "success",
                    title: "編輯成功"
                  });
                  this.$root.$emit(
                    "bv::hide::modal",
                    "modalCategory",
                    "#btnShow"
                  );
                  this.apiGetCarBrand();
                } else {
                  this.modal.state.name = false;
                  this.invalidFeedback = res.data.error;
                }
              })
              .catch(function(error) {
                Toast.fire({
                  icon: "error",
                  title: "編輯失敗",
                  text: "錯誤 " + error
                });
              });
            break;
          case 2:
            Category.style.model
              .update(
                this.activeMake,
                this.modal.id,
                {
                  name: this.modal.form.name
                },
                this.token
              )
              .then(res => {
                if (res.status <= 201) {
                  Toast.fire({
                    icon: "success",
                    title: "編輯成功"
                  });
                  this.apiGetModel(this.activeMake);
                  this.$root.$emit(
                    "bv::hide::modal",
                    "modalCategory",
                    "#btnShow"
                  );
                } else {
                  this.modal.state.name = false;
                  this.invalidFeedback = res.data.error;
                }
              })
              .catch(function(error) {
                this.modal.state.name = false;
                this.invalidFeedback = error;
              });
            break;
          case 3:
            Category.style.year
              .update(
                this.activeMake,
                this.activeModel,
                this.modal.id,
                {
                  publish_year: this.modal.form.publish_year.toString(),
                  type: this.modal.form.type,
                  displacing: this.modal.form.displacing
                },
                this.token
              )
              .then(res => {
                if (res.status <= 201) {
                  Toast.fire({
                    icon: "success",
                    title: "編輯成功"
                  });
                  this.apiGetCarYear(this.activeMake, this.activeModel);
                  this.$root.$emit(
                    "bv::hide::modal",
                    "modalCategory",
                    "#btnShow"
                  );
                } else {
                  Toast.fire({
                    icon: "error",
                    title: "編輯失敗",
                    text: res.data.error
                  });
                }
              })
              .catch(function(error) {
                Toast.fire({
                  icon: "error",
                  title: "編輯失敗",
                  text: "錯誤 " + error
                });
              });
        }
      } else {
        switch (this.modal.level) {
          case 1:
            Category.style.brand
              .create({ name: this.modal.form.name }, this.token)
              .then(res => {
                if (res.status <= 201) {
                  Toast.fire({
                    icon: "success",
                    title: "新增成功"
                  });
                  this.$root.$emit(
                    "bv::hide::modal",
                    "modalCategory",
                    "#btnShow"
                  );
                  this.apiGetCarBrand();
                } else {
                  this.modal.state.name = false;
                  this.invalidFeedback = res.data.error;
                }
              })
              .catch(function(error) {
                this.modal.state.name = false;
                this.invalidFeedback = error;
              });
            break;
          case 2:
            Category.style.model
              .create(
                this.activeMake,
                {
                  name: this.modal.form.name
                },
                this.token
              )
              .then(res => {
                if (res.status <= 201) {
                  Toast.fire({
                    icon: "success",
                    title: "新增成功"
                  });
                  this.apiGetModel(this.activeMake);
                  this.$root.$emit(
                    "bv::hide::modal",
                    "modalCategory",
                    "#btnShow"
                  );
                } else {
                  this.modal.state.name = false;
                  this.invalidFeedback = res.data.error;
                }
              })
              .catch(function(error) {
                this.modal.state.name = false;
                this.invalidFeedback = error;
              });
            break;
          case 3:
            Category.style.year
              .create(
                this.activeMake,
                this.activeModel,
                {
                  publish_year: this.modal.form.publish_year.toString(),
                  type: this.modal.form.type,
                  displacing: this.modal.form.displacing
                },
                this.token
              )
              .then(res => {
                if (res.status <= 201) {
                  Toast.fire({
                    icon: "success",
                    title: "新增成功"
                  });
                  this.apiGetCarYear(this.activeMake, this.activeModel);
                  this.$root.$emit(
                    "bv::hide::modal",
                    "modalCategory",
                    "#btnShow"
                  );
                } else {
                  Toast.fire({
                    icon: "error",
                    title: "新增失敗",
                    text: res.data.error
                  });
                }
              })
              .catch(function(error) {
                Toast.fire({
                  icon: "error",
                  title: "新增失敗",
                  text: "錯誤 " + error
                });
              });
        }
      }
    }
  },
  mounted() {}
};
</script>
